var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TextField',{attrs:{"bind-value":_vm.bindValue,"label":_vm.label,"default-rules":_vm.defaultRules,"rules":_vm.rules,"required-label":_vm.requiredLabel},on:{"input":_vm.emitInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }